jQuery(document).ready(function ($) {
    const notices = $('.notice');

    $.fn.adjustHeight = function () {
        this.each(function () {
            let height = $(this).find('span').height();

            $(this).css('height', height + 'px');
        });

        return this;
    }

    $(window).on('resize', function (event) {
        notices.adjustHeight();
    });

    notices.adjustHeight();
});